// extracted by mini-css-extract-plugin
export default {"PageContainer":"_PageContainer--l5Wte","TemplateGroup":"_TemplateGroup--B1ZJu","Description":"_Description--qk0F0"};